import React from 'react'

const Offers = () => {
    return (
        <div className="h-screen pt-[120px] max-w-[900px] mx-auto">
            <h1 className="text-2xl font-bold">Offers Page</h1>
        </div>
    )
}

export default Offers